import React, { useState, useEffect } from 'react';
import ModPortal from './pages/ModPortal';
import AdminPanel from './pages/AdminPanel';
import PlatformWallet from './pages/PlatformWallet';
import Dashboard from './pages/Dashboard';
import Health from './pages/Health';
import BloodBank from './pages/BloodBank';
import PiPaymentDebugger from './pages/PiPaymentDebugger';
import Reminders from './pages/Reminders';
import CardNew from './pages/CardNew';
import CardView from './pages/CardView';
import Referral from './pages/Referral';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Admin from './pages/Admin';
import Contact from './pages/Contact';
import Connections from './pages/Connections';
import Ledger from './pages/Ledger';
import Chat from './pages/Chat';
import Notifications from './pages/Notifications';
import Inbox from './pages/Inbox';
import Support from './pages/Support';
import Settings from './pages/Settings';
import XpertCreation from './pages/XpertCreation';
import Weather from './pages/Weather';
import Zodiac from './pages/Zodiac';
import Whitepaper from './pages/Whitepaper';
import Communities from './pages/Communities';
import OnlineGame from './pages/OnlineGame';
import Tools from './pages/Tools';
import Games from './pages/Games';
import TaskCenter from './pages/TaskCenter';
import CVBuilder from './pages/CVBuilder';
import Tutoring from './pages/Tutoring';
import Airdrops from './pages/Airdrops';
import Home from './pages/Home';
import ProfileGate from './profileGate';
import PostDetail from './pages/PostDetail';
import Profile from './pages/Profile';
import WritePost from './pages/WritePost';
import Leaderboard from './pages/Leaderboard';
import Navbar from './components/Navbar';
import MyTransactions from './components/MyTransactions';
import Cart from './pages/Cart';
import Forum from './pages/Forum';
import CommunityFooter from './components/CommunityFooter';
import AdminDashboard from './components/AdminDashboard';
import GamesHub from './components/GamesHub';
import MatrimonyApp from './components/MatrimonyApp';
import NFTApp from './components/NFTApp';
import FamilyTreeApp from './components/FamilyTreeApp';
import PetCareApp from './components/PetCareApp';
import AcademyApp from './components/AcademyApp';
import RealtyHome from './components/realty/RealtyHome';
import TravelMarketplace from './components/TravelMarketplace';
import MeetupMarketplace from './components/MeetupMarketplace';
import RealtyPropertyDetail from './components/realty/RealtyPropertyDetail';
import RealtyPostAd from './components/realty/RealtyPostAd';
import RealtyDashboard from './components/realty/RealtyDashboard';
import { isRealtyLoggedIn, realtyApi, setRealtyToken } from './components/realty/realtyApi';
import './components/realty/realty.css';
import FreelanceMarketplace from './components/FreelanceMarketplace';
import ShoppingHub from './pages/ShoppingHub';
import Services from './pages/Services';
import ServiceProviderProfile from './pages/ServiceProviderProfile';
import ServiceProviderRegister from './pages/ServiceProviderRegister';
import MerchantRegister from './pages/MerchantRegister';
import BrandKit from './pages/BrandKit';
import MerchantMarketplace from './components/MerchantMarketplace';
import DpinMarketplace from './components/DpinMarketplace';
import './App.css';
import VideoFeed from './pages/Videos/VideoFeed';
import VideoUpload from './pages/Videos/VideoUpload';
import VideoWatch from './pages/Videos/VideoWatch';
import VideoChannel from './pages/Videos/VideoChannel';
import MerchantMap from './pages/MerchantMap';
import MerchantPage from './pages/MerchantPage';
import MerchantDirectory from './pages/MerchantDirectory';
import MerchantAdmin from './pages/MerchantAdmin';
import MerchantTiers from './pages/MerchantTiers';
import MySubscriptions from './pages/MySubscriptions';
import CareersApp from './components/CareersApp';
import ChannelApply from './pages/Videos/ChannelApply';

function App() {
  // Referral: ?ref=CODE ko yaad rakho + click track
  if (typeof window !== 'undefined') {
    try {
      const _p = new URLSearchParams(window.location.search);
      const _ref = _p.get('ref');
      if (_ref && !localStorage.getItem('pen_ref')) {
        localStorage.setItem('pen_ref', _ref);
        fetch('/api/referrals/track-click/', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code: _ref }),
        }).catch(() => {});
      }
    } catch (_e) {}
  }

  const [user, setUser] = useState(null);
  const isAdmin = (u) => u && u.username === 'khalidxpert';
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (window.Pi) {
      window.Pi.init({ version: "2.0", sandbox: true });
    }
    const token = localStorage.getItem('token');
    const username = localStorage.getItem('username');
    const avatar = localStorage.getItem('avatar');
    if (token && username) {
      setUser({ username, token, avatar });
    }
    setLoading(false);

    // Auto-connect to XpertRealty's own Pi login if this is a /realty page and not yet connected there
    if (window.location.pathname.startsWith('/realty') && !isRealtyLoggedIn() && window.Pi) {
      window.Pi.authenticate(['username', 'payments'], () => {})
        .then((authResult) => realtyApi.piLogin(authResult.accessToken))
        .then((data) => setRealtyToken(data.token))
        .catch((e) => console.log('Realty auto-login skipped:', e.message));
    }
  }, []);

  const onIncompletePaymentFound = async (payment) => {
    console.log('Incomplete payment found:', payment);
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
      const txid = payment.transaction?.txid;
      if (!txid) {
        console.log('No txid - payment was cancelled, skipping');
        return;
      }
      await fetch('/api/payments/approve/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Token ${token}` },
        body: JSON.stringify({ paymentId: payment.identifier })
      });
      await fetch('/api/payments/complete/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Token ${token}` },
        body: JSON.stringify({ paymentId: payment.identifier, txid })
      });
    } catch (err) {
      console.error('Failed to complete incomplete payment:', err);
    }
  };

  const loginWithPi = async () => {
    try {
      if (!window.Pi) {
        alert('Please open PenFlow inside Pi Browser!');
        return;
      }
      window.Pi.init({ version: "2.0", sandbox: true });
      const scopes = ['username', 'payments'];
      const authResult = await window.Pi.authenticate(scopes, onIncompletePaymentFound);
      const response = await fetch('/api/auth/pi/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ accessToken: authResult.accessToken, ref: localStorage.getItem('pen_ref') || '' })
      });
      const data = await response.json();
      if (data.token) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('username', data.username);
        if (data.avatar) localStorage.setItem('avatar', data.avatar);
        setUser({ username: data.username, token: data.token, avatar: data.avatar || null });
      }
    } catch (err) {
      console.error('Login failed:', err);
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('avatar');
    setUser(null);
  };

  const updateUserAvatar = (avatarUrl) => {
    localStorage.setItem('avatar', avatarUrl);
    setUser(prev => ({ ...prev, avatar: avatarUrl }));
  };

  if (loading) return <div className="loading">Loading PenFlow...</div>;

  return (
    <Router>
      <div className="App">
        <Navbar user={user} onLogin={loginWithPi} onLogout={logout} />
        <Routes>
          <Route path="/" element={<Home user={user} />} />
          <Route path="/post/:id" element={<PostDetail user={user} />} />
          <Route path="/profile/:username" element={<Profile user={user} onAvatarUpdate={updateUserAvatar} />} />
   2      <Route path="/write" element={<WritePost user={user} />} />
          <Route path="/leaderboard" element={<Leaderboard user={user} />} />
          <Route path="/admin" element={<Admin user={user} isAdmin={isAdmin(user)} />} />
          <Route path="/contact" element={<Contact user={user} />} />
          <Route path="/connections" element={<Connections user={user} />} />
          <Route path="/ledger" element={<Ledger user={user} />} />
          <Route path="/chat/:username" element={<Chat user={user} />} />
          <Route path="/notifications" element={<Notifications user={user} />} />
          <Route path="/inbox" element={<Inbox user={user} />} />
          <Route path="/support" element={<Support user={user} />} />
          <Route path="/settings" element={<Settings user={user} onAvatarUpdate={updateUserAvatar} />} />
          <Route path="/xpertcreation" element={<XpertCreation />} />
          <Route path="/weather" element={<Weather />} />
          <Route path="/zodiac" element={<Zodiac />} />
          <Route path="/whitepaper" element={<Whitepaper />} />
          <Route path="/communities" element={<Communities user={user} isAdmin={isAdmin(user)} />} />
          <Route path="/online-game" element={<OnlineGame user={user} />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/games" element={<Games />} />
          <Route path="/videos" element={<VideoFeed />} />
          <Route path="/videos/upload" element={<VideoUpload />} />
          <Route path="/videos/:id" element={<VideoWatch />} />
          <Route path="/videos/channel/:username" element={<VideoChannel />} />
          <Route path="/videos/channel-apply" element={<ChannelApply />} />
          <Route path="/merchants" element={<MerchantMap />} />
          <Route path="/merchants/:slug" element={<MerchantPage />} />
          <Route path="/directory" element={<MerchantDirectory />} />
          <Route path="/merchant-admin" element={<MerchantAdmin user={user} />} />
          <Route path="/merchant-tiers" element={<MerchantTiers />} />
          <Route path="/my-subscriptions" element={<MySubscriptions />} />
          <Route path="/dpin" element={<DpinMarketplace />} />
          <Route path="/marketplace" element={<MerchantMarketplace />} />
          <Route path="/freelance" element={<FreelanceMarketplace />} />
        <Route path="/services" element={<Services user={user} />} />
        <Route path="/services/register" element={<ServiceProviderRegister user={user} />} />
        <Route path="/services/:id" element={<ServiceProviderProfile user={user} />} />
          <Route path="/shopping" element={<ShoppingHub />} />
          <Route path="/merchant-register" element={<ProfileGate need={['email', 'phone']} projectName="Merchant"><MerchantRegister /></ProfileGate>} />
          <Route path="/brand-kit" element={<BrandKit />} />
          <Route path="/realty" element={<RealtyHome />} />
          <Route path="/realty/property/:id" element={<RealtyPropertyDetail />} />
          <Route path="/realty/post-ad" element={<RealtyPostAd />} />
          <Route path="/realty/dashboard" element={<RealtyDashboard />} />
          <Route path="/travel" element={<ProfileGate need={['country']} projectName="Travel"><TravelMarketplace /></ProfileGate>} />
          <Route path="/meetup" element={<MeetupMarketplace />} />
          <Route path="/family-tree" element={<FamilyTreeApp />} />
          <Route path="/petcare" element={<PetCareApp />} />
          <Route path="/academy" element={<AcademyApp />} />
          <Route path="/matrimony" element={<MatrimonyApp />} />
          <Route path="/nft" element={<NFTApp />} />
          <Route path="/tasks" element={<TaskCenter user={user} />} />
          <Route path="/cv-builder" element={<CVBuilder />} />
          <Route path="/referral" element={<Referral />} />
          <Route path="/tutoring" element={<Tutoring />} />
          <Route path="/pi-debugger" element={<PiPaymentDebugger />} />
          <Route path="/reminders" element={<Reminders />} />
          <Route path="/card/new" element={<CardNew />} />
          <Route path="/card/:token" element={<CardView />} />
          <Route path="/health" element={<Health />} />
          <Route path="/blood-bank" element={<BloodBank />} />
          <Route path="/careers" element={<CareersApp user={user} />} />
          <Route path="/airdrops" element={<Airdrops user={user} />} />
          <Route path="/admin-dashboard" element={<AdminDashboard user={user} />} />
          <Route path="/my-transactions" element={<MyTransactions user={user} />} />
          <Route path="/cart" element={<Cart user={user} />} />
          <Route path="/dashboard" element={<Dashboard user={user} />} />
                  <Route path="/forum" element={<Forum user={user} />} />
          <Route path="/forum/b/:slug" element={<Forum user={user} mode="board" />} />
          <Route path="/forum/t/:id" element={<Forum user={user} mode="thread" />} />
          <Route path="/forum/new/:slug" element={<Forum user={user} mode="new" />} />
          <Route path="/admin/wallet" element={<PlatformWallet user={user} />} />
          <Route path="/admin/panel" element={<AdminPanel user={user} />} />
          <Route path="/modportal" element={<ModPortal user={user} />} />
        </Routes>
          <CommunityFooter />
      </div>
    </Router>
  );
}

export default App;
